"use client";

import { useTranslations } from "next-intl";
import styles from "./switcher.module.css";

export default function Switcher({
  isActive,
  onClickAction,
}: {
  isActive: boolean;
  onClickAction: () => void;
}) {
  const t = useTranslations("MyAccount");
  return (
    <div
      onClick={async () => {
        await onClickAction();
      }}
      className={styles.switcher}
      role="switch"
      aria-checked={isActive}
      tabIndex={0}
      onKeyDown={async (e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          await onClickAction();
        }
      }}
    >
      <div className={`${isActive ? styles.active : ""} ${styles.button}`}>
        {t("yes")}
      </div>
      <div className={`${!isActive ? styles.active : ""} ${styles.button}`}>
        {t("no")}
      </div>
    </div>
  );
}

export function SwitcherLoading() {
  return <div className={`${styles.switcher} ${styles.isLoading}`}></div>;
}
